import Marquee from "react-fast-marquee";

const items = [
  "House Painting",
  "Ceilings",
  "Fencing",
  "Rubbish Removal",
  "Lawns",
  "Carpentry",
  "Maintenance",
  "Roofing",
];

export default function BrandMarquee() {
  return (
    <section
      data-testid="marquee"
      className="border-y border-forest-ink/10 bg-bone-200 py-5"
      aria-hidden="true"
    >
      <Marquee speed={28} gradient={false} autoFill>
        {items.map((it, i) => (
          <span key={i} className="flex items-center">
            <span className="text-forest text-xs md:text-sm tracking-[0.32em] uppercase px-8">
              {it}
            </span>
            <span className="text-clay">✳</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
